<template>
    <div class="editor-switch">
        <Switcher
            :model-value="editorType === 'Lightweight' ? true : false"
            @update:model-value="switchEditor"
        />
        <span class="editor-switch__label">
            Professional editor
        </span>
    </div>
</template>

<script>
import Switcher from '@speechki-frontend/shared/ui/Switcher';

export default {
    name: 'EditorSwitch',
    components: {
        Switcher
    },
    computed: {
        editorType() {
            return this.$route.path.includes('/light/') ? 'Professional' : 'Lightweight';
        }
    },
    methods: {
        switchEditor() {
            const target = this.$route.path.includes('/light/') ? 'embed' : 'editor-light';

            this.$router.replace({
                ...this.$route,
                name: target
            });
        }
    }
};
</script>

<style lang="scss" src="./EditorSwitch.scss"></style>
